import { Box, Text } from "@chakra-ui/react";
import { STEPS, EYEBROW_COLORS } from "../constants";

export function EyebrowBadge({ stepId }: { stepId: number }) {
  const step = STEPS.find((s) => s.id === stepId);
  if (!step) return null;
  const colors = EYEBROW_COLORS[stepId];
  return (
    <Box display="inline-flex" alignItems="center" borderRadius="full" borderWidth="1px" borderColor={colors.border} bg={colors.bg} px={3} py={1}>
      <Text fontSize="xs" fontWeight="medium" letterSpacing="wider" textTransform="uppercase" color={colors.color}>
        {step.eyebrow}
      </Text>
    </Box>
  );
}
